import md5 from "js-md5";
//随机生成字符串
function randomString(length, chars) {
  var result = "";
  for (var i = length; i > 0; --i)
    result += chars[Math.floor(Math.random() * chars.length)];
  return result;
}

//  参数加密
function QMdata(data) {
  // 随机字符串
  let Nonce = randomString(
    "32",
    "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
  );
  let Time = Math.trunc(new Date().getTime() / 1000);
  let Appid = "VoiceRecord";
  let AppSecret = "sz4QIuQLNkZXB0AFIMBmmRIjSRiJSa03";
  let Sign = md5(
    `Appid=${Appid}&AppSecret=${AppSecret}&Nonce=${Nonce}&Time=${Time}&data=${JSON.stringify(
      data
    )}`
  )
    .toString()
    .toUpperCase();
  return {
    Appid: "VoiceRecord",
    AppSecret: "sz4QIuQLNkZXB0AFIMBmmRIjSRiJSa03",
    Nonce: Nonce, // 32位随机字符串
    Time: Time, //当前时间戳（秒）
    Sign: Sign, //签名Appid = & AppSecret = & Nonce = & Time = & data = 拼凑成的字符串MD5加密转大写
    data: data
  };
}
export default { QMdata };
